module.exports = __webpack_public_path__ + "img/jelly.be5030ca.webp";